import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import { IEquipmentSingleOrder } from 'API';
import { ListDivider } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useState } from 'react';
import { EquipmentItem } from './EquipmentItem';
import { AccordionArrowPurple, AccordionArrowPurpleClose } from 'Images';

interface IEquipmentListProps {
  orderItems: IEquipmentSingleOrder[];
}

export const EquipmentList = ({ orderItems }: IEquipmentListProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const isSuppliedOrPartial = !!orderItems.find((item) => item.isSupplied);

  return isDesktop ? (
    <>
      <Typography component={'h3'} variant='h5'>
        {dictionary.RecentOrders.yourProducts}
      </Typography>
      <Grid
        container
        direction={'column'}
        mt={3}
        sx={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          border: '1px solid',
          borderColor: 'primary.shade_200',
          p: 3,
        }}
      >
        <Grid container item mb={2}>
          <Grid item xs={6} md={isSuppliedOrPartial ? 4 : 5}>
            <Typography>{dictionary.orderDialog.itemName}</Typography>
          </Grid>
          <Grid item xs={6} md={2}>
            <Typography>{dictionary.orderDialog.quantity}</Typography>
          </Grid>
          <Grid item xs={6} md={isSuppliedOrPartial ? 4 : 5}>
            <Typography>{dictionary.orderDialog.notes}</Typography>
          </Grid>
          {isSuppliedOrPartial && (
            <Grid item xs={6} md={2}>
              <Typography>{dictionary.orderDialog.status}</Typography>
            </Grid>
          )}
        </Grid>
        <ListDivider />
        {orderItems.map((item) => (
          <EquipmentItem
            key={item.itemCatalogNumber}
            item={item}
            isSuppliedOrPartial={isSuppliedOrPartial}
          />
        ))}
      </Grid>
    </>
  ) : (
    <Accordion
      sx={{
        width: '100%',
        boxShadow: 'none',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        borderRadius: '16px !important',
        '&:before': {
          display: 'none',
        },
        mb: '24px !important',
      }}
    >
      <AccordionSummary
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
        expandIcon={
          <>
            {!isExpanded && (
              <Avatar
                src={AccordionArrowPurple}
                sx={{
                  width: '32px',
                  height: '32px',
                }}
              />
            )}
            {isExpanded && (
              <Avatar
                src={AccordionArrowPurpleClose}
                sx={{
                  width: '32px',
                  height: '32px',
                  rotate: '180deg',
                }}
              />
            )}
          </>
        }
        sx={{ p: '8px 16px' }}
      >
        <Typography>{dictionary.RecentOrders.yourProducts}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: '0 16px 16px 16px' }}>
        <Divider
          aria-hidden={true}
          sx={{ borderColor: 'primary.shade_100', mb: 3 }}
        />
        <Grid container>
          <Grid item xs={9.5}>
            <Typography variant='body4'>
              {dictionary.orderDialog.itemName}
            </Typography>
          </Grid>
          <Grid item xs={2.5}>
            <Typography variant='body4' sx={{ pl: '5px' }}>
              {dictionary.orderDialog.quantity}
            </Typography>
          </Grid>
        </Grid>
        {orderItems.map((item) => (
          <EquipmentItem
            key={item.itemCatalogNumber}
            item={item}
            isSuppliedOrPartial={isSuppliedOrPartial}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
